class StorageType {
  static local = 1;
  static session = 2;
  static 1 = 'local';
  static 2 = 'session';
}

interface IStorageProvider {
  get: (key: string) => string;
  remove: (key: string) => void;
  set: (key: string, value: string) => void;
  clear: () => void;
}

interface IStorageFactory {
  getStorage: (type: StorageType) => IStorageProvider;
}

export { StorageType, IStorageProvider, IStorageFactory };
